<template>
  <div class="app-container">
    <!--弹窗-->
    <div style="text-align: left; margin-bottom: 10px">
      <el-button type="primary" @click="openModel">打开弹窗</el-button>
    </div>
    <!--按钮-->
    <div style="text-align: left; margin-bottom: 10px" class="flex align-center">
      <button class="btn-16-bg-85 mr-10">按钮1</button>
      <button class="btn-16-bd-85 mr-10">按钮2</button>
      <button class="btn-16-bd-ff5555 mr-10">删除</button>
      <button class="btn-24-bg-f5971d mr-10">按钮3</button>
      <button class="btn-24-bd-f5971d btn-hover mr-10">按钮4</button>
      <button class="btn-30-bg-82b925 mr-10">按钮5</button>
      <button class="btn-30-bg-82b925-big mr-10">按钮6</button>
      <button class="btn-16-bg-82b925-r mr-10">按钮7</button>
      <button class="btn-16-bg-ff5555-r mr-10">按钮8</button>
      <button class="btn-16-bd-85-r mr-10">按钮9</button>
      <button class="btn-24-bg-ff mr-10">按钮10</button>
      <button class="btn-30-border-85 mr-10">按钮11</button>
      <button class="btn-30-border-30313a mr-10">按钮111</button>
      <button class="btn-30-border-30313a-small mr-10">按钮小</button>
      <button class="btn-30-border-30313a-e2 mr-10">按钮小</button>
      <button class="btn-30-bg-f5971d-s mr-10">按钮12</button>
      <button class="btn-30-bg-f5971d mr-10">按钮小</button>
      <button class="btn-30-border-f5971d-s mr-10">按钮13</button>
      <button class="btn-24-bd-e2 mr-10">按钮14</button>
      <button class="btn-24-bd-e2-bg-ff mr-10">按钮15</button>
      <button class="btn-20-bg-3d3e46 mr-10">按钮16</button>
      <div class="tip-20-bg-30313a">
        <i class="el-icon-plus font-bold"></i>
      </div>
    </div>
    <!--分页-->
    <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
    <div class="my-divider"></div>
    <div class="flex-1" style="padding-bottom: 20px; margin-left: -20px">
      <div class="h-100 flex">
        <!-- 使用横向拖动的时候，必须确定某边元素id，并传入, 默认为左边元素，id为moveLeft -->
        <div class="h-100" id="moveLeft" style="width: 200px">
          <!--not-operate 为false的时候有操作按钮，为true的时候没有操作按钮-->
          <cate-menu :not-operate="true"  :menu-data="menuData" @on-edit="onEdit" @on-delete="onDelete" @on-choose="onChooseMenu" @on-add="onAdd" :choose-id="chooseMenuId"></cate-menu>
        </div>
        <move-horizon></move-horizon>
        <div class="flex-1 flex-column">
          <!-- 使用纵向拖动的时候，必须确定某方元素id，并传入, 默认为上方元素，id为moveTop -->
          <div id="moveTop" style="height: 300px">
            <div class="flex" style="height: 50px; background: #fff; margin-top: 20px">
              <div class="h-100 flex-1">使用横向拖动的时候，必须确定某边元素id，并传入, 默认为左边元素，id为moveLeft</div>
              <move-horizon move-dom="right" :min="50" move-id="smallMoveRight" size="small"></move-horizon>
              <div class="h-100" style="width: 100px;overflow: hidden;" id="smallMoveRight">
                <div style="color: #f5971d; line-height: 50px">哎呀我太长了不够显示的时候我得隐藏呀</div>
              </div>
            </div>
          </div>
          <move-vertical :max="450" :min="150"></move-vertical>
          <div class="flex-1" style="padding-top: 200px">
            使用纵向拖动的时候，必须确定某方元素id，并传入, 默认为上方元素，id为moveTop
          </div>
        </div>
      </div>
    </div>
    <el-dialog :modal-append-to-body="false" :append-to-body="false"  title="弹框标题" :visible.sync="isDialogShow">
      <div>内容</div>
      <div slot="footer">
        <div class="btn-30-border-f5971d-s mr-10">重置</div>
        <div class="btn-30-bg-f5971d-s">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import MoveHorizon from '../../components/MoveHorizon'
import MoveVertical from '../../components/MoveVertical'
import CateMenu from '../../components/CateMenu'
export default {
  name: 'Welcome3',
  components: {Pagination, MoveHorizon, MoveVertical, CateMenu},
  data () {
    return {
      pageSize: 25, // 总页数
      pageNo: 2, // 当前页数
      pageTotal: 15, // 当前页条数
      total: 370, // 总条数
      isDialogShow: false,
      menuData: [{
        'id': 2,
        'name': '居立方昆明分公司',
        'children': [{
          'id': 3,
          'name': '总经办',
          'parentId': 2,
          'children': [{
            'id': 300,
            'name': '行政部',
            'parentId': 3,
            'children': [{
              'id': 3000,
              'name': '人事部',
              'parentId': 300
            }, {
              'id': 3001,
              'name': '人力资源部',
              'parentId': 300
            }]
          }, {
            'id': 301,
            'name': '客服部',
            'parentId': 3,
            'children': [{
              'id': 3010,
              'name': '售后部',
              'parentId': 301
            }, {
              'id': 3011,
              'name': '售前部',
              'parentId': 301
            }]
          }, {
            'id': 302,
            'name': '销售部',
            'parentId': 3
          }]
        }, {
          'id': 31,
          'name': '董事会',
          'parentId': 2,
          'children': [{
            'id': 310,
            'name': '测试2',
            'parentId': 2,
            'children': []
          }]
        }]
      }, {
        'id': 4,
        'name': '成都分公司',
        'children': [{
          'id': 10,
          'name': '总经办',
          'parentId': 4
        }]
      }, {
        'id': 5,
        'name': '深圳分公司'
      }],
      chooseMenuId: 3010
    }
  },
  methods: {
    jump (id) {
    },
    openModel () {
      this.isDialogShow = true
    },
    onChooseMenu (menu) {
      this.chooseMenuId = menu.id
    },
    onAdd (menu) {
    },
    onDelete (menu) {
    },
    onEdit (menu) {
    }
  }
}
</script>

<style scoped>
.my-divider {
  height: 50px;
  width: calc(100% + 40px);
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  margin-left: -20px;
  margin-right: -20px;
  z-index: 8;
}
</style>



// WEBPACK FOOTER //
// src/pages/welcome2/index01.vue